<template>
  <div class="bakgrund"></div>

  <h2 v-if="header">{{ header }}</h2>
  
  <List
    v-if="listItems && listItems.length"
    :listItems="listItems"
  ></List>

  <div v-if="linkUrl && texts.linkText" class="lasMerContainer">
    <a class="lasMer" :href="linkUrl">{{ texts.linkText }}</a>
  </div>
</template>

<script>
import List from "./components/list.vue";
import divaListService from "../plugins/divaListService";

export default {
  name: "DivaListBlock",
  props: {
    id: String,
    baseApiUrl: String,
    divaUrl: String,
    numberOfItems: Number,
    header: String,
    linkUrl: String,
    texts: Object,
  },
  data: function () {
    return {
      take: 10,
      listItems: undefined
    };
  },
  components: {
    List
  },
  created() {
    this.$.appContext.app.config.globalProperties = {
      $texts: this.texts,
    }
    
    this.take = this.numberOfItems == 0 ? this.take : this.numberOfItems;
    this.getItems();
  },
  methods: {
    getItems() {
      divaListService
        .getItems(this.baseApiUrl, this.divaUrl, this.take)
        .then((result) => {
          if (result && result.status == 200) {
            this.listItems = result.data.listItems;
          }
        });
    },
  }
};
</script>
